import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CompanySelectPageRoutingModule } from './company-select-routing.module';

import { CompanySelectPage } from './company-select.page';
import { ComponentsModule } from 'src/components/components.module';
import { CommonLibModule } from 'common-lib';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CompanySelectPageRoutingModule,
    
    ComponentsModule,
    CommonLibModule,
  ],
  declarations: [CompanySelectPage]
})
export class CompanySelectPageModule {}
